import { render, staticRenderFns } from "./DealActions.vue?vue&type=template&id=2b1dcafd&scoped=true&"
import script from "./DealActions.vue?vue&type=script&lang=ts&"
export * from "./DealActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1dcafd",
  null
  
)

export default component.exports